import { gql } from '@apollo/client';

export const GENERATE_MAINTENANCE = gql`
  mutation BI_REPORT_SERVICE_generateMaintenance($type: FileType!, $recipients: [String]!) {
    generateMaintenance(type: $type, recipients: $recipients)
  }
`;

export const GENERATE_FILES_FOR_AUTO_RENEW = gql`
  mutation BI_REPORT_SERVICE_generateFilesForAutoRenew(
    $sponsorId: String!
    $effectiveDate: String!
    $recipients: [String!]!
  ) {
    generateFilesForAutoRenew(sponsorId: $sponsorId, effectiveDate: $effectiveDate, recipients: $recipients)
  }
`;
